/* Park's Jewels wishlist - saves to the shopper's browser (localStorage) */
(function () {
  var KEY = 'pj_wishlist';
  var HEART = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M12 20.5s-7.5-4.6-9.3-9.1C1.5 8.3 3.4 4.5 7 4.5c2.1 0 3.6 1.2 5 3 1.4-1.8 2.9-3 5-3 3.6 0 5.5 3.8 4.3 6.9-1.8 4.5-9.3 9.1-9.3 9.1z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>';

  function load() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    refresh();
  }
  function has(h) { return load().indexOf(h) !== -1; }
  function toggle(h) {
    var list = load();
    var i = list.indexOf(h);
    if (i === -1) { list.unshift(h); } else { list.splice(i, 1); }
    save(list);
  }
  function handleFrom(href) {
    var m = (href || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100); } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  var css = '' +
    '.pj-wl-card{position:absolute;top:10px;right:10px;z-index:3;width:36px;height:36px;border-radius:50%;border:0;background:rgba(255,255,255,.9);color:#111;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 1px 4px rgba(0,0,0,.15);padding:0}' +
    '.pj-wl-card svg path,.pj-wl-pdp svg path,.pj-wl-head svg path{fill:none}' +
    '.pj-wl-on svg path{fill:#e8a0bf;stroke:#e8a0bf}' +
    '.pj-wl-pdp{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;margin-top:12px}' +
    '.pj-wl-head{position:relative;display:inline-flex;align-items:center;background:none;border:0;padding:0;color:inherit;cursor:pointer}' +
    '.pj-wl-head svg{width:24px;height:24px}' +
    '.pj-wl-head svg path{stroke-width:1}' +
    '@media (max-width:699px){.header__secondary-nav .pj-wl-head{display:none}}' +
    '@media (min-width:700px){.pj-wl-head--m{display:none!important}}' +
    '.pj-wl-count{position:absolute;top:-6px;right:-8px;min-width:16px;height:16px;border-radius:8px;background:#e8a0bf;color:#fff;font-size:10px;line-height:16px;text-align:center;padding:0 4px}' +
    '.pj-wl-count:empty{display:none}' +
    '.pj-wl-overlay{position:fixed;inset:0;background:rgba(0,0,0,.4);z-index:9998;opacity:0;visibility:hidden;transition:opacity .25s}' +
    '.pj-wl-panel{position:fixed;top:0;right:0;height:100%;width:min(420px,100%);background:#fff;color:#111;z-index:9999;transform:translateX(100%);transition:transform .3s;display:flex;flex-direction:column}' +
    '.pj-wl-open .pj-wl-overlay{opacity:1;visibility:visible}' +
    '.pj-wl-open .pj-wl-panel{transform:none}' +
    '.pj-wl-top{display:flex;justify-content:space-between;align-items:center;padding:20px 24px;border-bottom:1px solid #eee}' +
    '.pj-wl-top h2{margin:0;font-size:20px}' +
    '.pj-wl-x{background:none;border:0;font-size:28px;line-height:1;cursor:pointer;color:inherit}' +
    '.pj-wl-body{overflow-y:auto;padding:16px 24px;flex:1}' +
    '.pj-wl-item{display:flex;gap:14px;align-items:center;padding:12px 0;border-bottom:1px solid #f2f2f2}' +
    '.pj-wl-item img{width:80px;height:100px;object-fit:cover;flex:none;background:#f6f6f6}' +
    '.pj-wl-info{flex:1;min-width:0}' +
    '.pj-wl-info a{color:inherit;text-decoration:none;display:block;margin-bottom:4px}' +
    '.pj-wl-rm{background:none;border:0;text-decoration:underline;cursor:pointer;color:#777;font-size:13px;padding:0;margin-top:6px}' +
    '.pj-wl-actions{display:flex;flex-wrap:wrap;gap:8px;align-items:center;margin-top:8px}' +
    '.pj-wl-var{height:40px;box-sizing:border-box;padding:0 10px;border:1px solid rgb(221,221,221);background:#fff;color:#111;font-size:13px;max-width:100%}' +
    '.pj-wl-add{height:40px!important;box-sizing:border-box!important;padding:0 16px!important;min-height:0!important;font-size:11px!important}' +
    '.pj-wl-add[disabled]{opacity:.5;cursor:not-allowed}' +
    '.pj-wl-msg{font-size:12px;color:#c0392b;width:100%}' +
    '.pj-wl-empty{text-align:center;color:#777;padding:40px 0}' +
    '.pj-wl-lock{overflow:hidden}';

  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function setBtn(btn, on) {
    btn.classList.toggle('pj-wl-on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    var label = btn.querySelector('.pj-wl-label');
    var text = on ? 'Saved to Wishlist' : 'Add to Wishlist';
    if (label && label.textContent !== text) label.textContent = text;
  }

  function addCardHearts() {
    document.querySelectorAll('product-card').forEach(function (card) {
      var fig = card.querySelector('.product-card__figure');
      if (!fig || fig.querySelector('.pj-wl-card')) return;
      var link = card.querySelector('a[href*="/products/"]');
      var h = link && handleFrom(link.getAttribute('href'));
      if (!h) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pj-wl-card';
      b.dataset.handle = h;
      b.innerHTML = HEART;
      setBtn(b, has(h));
      fig.appendChild(b);
    });
  }

  function addProductButton() {
    var h = handleFrom(location.pathname);
    if (!h || document.querySelector('.pj-wl-pdp')) return;
    var buy = document.querySelector('.product-info buy-buttons') || document.querySelector('buy-buttons');
    if (!buy) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'button button--outline w-full pj-wl-pdp';
    b.dataset.handle = h;
    b.innerHTML = HEART + '<span class="pj-wl-label">Add to Wishlist</span>';
    setBtn(b, has(h));
    buy.insertAdjacentElement('afterend', b);
  }

    function headBtn(extra) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pj-wl-head' + extra;
    b.setAttribute('aria-label', 'Open wishlist');
    b.innerHTML = HEART + '<span class="pj-wl-count"></span>';
    return b;
  }
  function addHeaderIcon() {
    var nav = document.querySelector('.header__secondary-nav');
    if (nav && !nav.querySelector('.pj-wl-head')) {
      var search = nav.querySelector('a[href*="/search"]');
      nav.insertBefore(headBtn(''), search || nav.firstChild);
    }
    var menu = document.querySelector('.header__primary-nav button[aria-controls="sidebar-menu"]');
    if (menu && !document.querySelector('.pj-wl-head--m')) {
      menu.insertAdjacentElement('afterend', headBtn(' pj-wl-head--m'));
    }
  }

  var panel;
  function buildPanel() {
    if (panel) return panel;
    panel = document.createElement('div');
    panel.className = 'pj-wl-root';
    panel.innerHTML = '<div class="pj-wl-overlay" data-wl-close></div>' +
      '<aside class="pj-wl-panel" role="dialog" aria-modal="true" aria-label="Wishlist">' +
      '<div class="pj-wl-top"><h2 class="h5">My Wishlist</h2><button type="button" class="pj-wl-x" aria-label="Close" data-wl-close>&times;</button></div>' +
      '<div class="pj-wl-body"></div></aside>';
    document.body.appendChild(panel);
    return panel;
  }

  function renderPanel() {
    var body = buildPanel().querySelector('.pj-wl-body');
    var list = load();
    if (!list.length) {
      body.innerHTML = '<p class="pj-wl-empty">Your wishlist is empty.<br>Tap the &#9825; on any item to save it here.</p>';
      return;
    }
    body.innerHTML = '<p class="pj-wl-empty">Loading&hellip;</p>';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    Promise.all(list.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var html = '';
      products.forEach(function (p, i) {
        if (!p) return;
        var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
        if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=200';
        var avail = (p.variants || []).filter(function (v) { return v.available; });
        var buy = '';
        if (!avail.length) {
          buy = '<button type="button" class="button button--outline pj-wl-add" disabled>Sold Out</button>';
        } else if (avail.length === 1) {
          buy = '<button type="button" class="button button--outline pj-wl-add" data-variant="' + avail[0].id + '">Add to Cart</button>';
        } else {
          buy = '<select class="pj-wl-var" aria-label="Choose an option">' + avail.map(function (v) {
            return '<option value="' + v.id + '">' + esc(v.title) + '</option>';
          }).join('') + '</select><button type="button" class="button button--outline pj-wl-add">Add to Cart</button>';
        }
        html += '<div class="pj-wl-item">' +
          (img ? '<a href="' + esc(p.url) + '"><img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy"></a>' : '') +
          '<div class="pj-wl-info"><a href="' + esc(p.url) + '" class="h6">' + esc(p.title) + '</a>' +
          '<div>' + money(p.price) + (p.available ? '' : ' &middot; Sold out') + '</div>' +
          '<div class="pj-wl-actions">' + buy + '<span class="pj-wl-msg"></span></div>' +
          '<button type="button" class="pj-wl-rm" data-handle="' + esc(list[i]) + '">Remove</button></div></div>';
      });
      body.innerHTML = html || '<p class="pj-wl-empty">Your wishlist is empty.</p>';
    });
  }

  function openPanel() {
    renderPanel();
    document.documentElement.classList.add('pj-wl-open', 'pj-wl-lock');
  }
  function closePanel() {
    document.documentElement.classList.remove('pj-wl-open', 'pj-wl-lock');
  }

  function refresh() {
    var list = load();
    document.querySelectorAll('.pj-wl-card, .pj-wl-pdp').forEach(function (b) {
      setBtn(b, list.indexOf(b.dataset.handle) !== -1);
    });
    document.querySelectorAll('.pj-wl-count').forEach(function (c) {
      var n = list.length ? String(list.length) : '';
      if (c.textContent !== n) c.textContent = n;
    });
  }

  function addToCart(btn) {
    var box = btn.closest('.pj-wl-actions');
    var sel = box.querySelector('.pj-wl-var');
    var id = sel ? sel.value : btn.dataset.variant;
    var msg = box.querySelector('.pj-wl-msg');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    btn.disabled = true;
    btn.textContent = 'Adding...';
    msg.textContent = '';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) throw d; return d; });
    }).then(function () {
      btn.textContent = 'Added!';
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      setTimeout(function () {
        closePanel();
        var drawer = document.getElementById('cart-drawer');
        if (drawer && typeof drawer.show === 'function') drawer.show();
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
      }, 600);
    }).catch(function (err) {
      btn.disabled = false;
      btn.textContent = 'Add to Cart';
      msg.textContent = (err && (err.description || err.message)) || 'Could not add to cart.';
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t.closest && t.closest('.pj-wl-card, .pj-wl-pdp');
    if (btn) { e.preventDefault(); e.stopPropagation(); toggle(btn.dataset.handle); return; }
    if (t.closest && t.closest('.pj-wl-head, a[href$="#wishlist"]')) { e.preventDefault(); openPanel(); return; }
    var add = t.closest && t.closest('.pj-wl-add');
    if (add) { if (!add.disabled) addToCart(add); return; }
    var rm = t.closest && t.closest('.pj-wl-rm');
    if (rm) { toggle(rm.dataset.handle); renderPanel(); return; }
    if (t.closest && t.closest('[data-wl-close]')) { closePanel(); }
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanel(); });
  window.addEventListener('storage', function (e) { if (e.key === KEY) refresh(); });

  /* Show size names capitalized (medium -> Medium, xs -> XS) without changing product data */
  var SIZE_RE = /^(xxs|xs|s|m|l|xl|xxl|xxxl|2xl|3xl|small|medium|large|extra small|extra large|x-small|x-large|one size|os)(\s*[-(].*)?$/i;
  function capSize(w) {
    return /^(small|medium|large|extra small|extra large|x-small|x-large|one size)$/i.test(w)
      ? w.toLowerCase().replace(/(^|[\s-])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); })
      : w.toUpperCase();
  }
  function fixSizeText(t) {
    var changed = false;
    var out = t.split(' / ').map(function (p) {
      var lead = p.match(/^\s*/)[0], trail = p.match(/\s*$/)[0];
      var core = p.trim();
      var pre = core.match(/^([A-Za-z][A-Za-z ]{0,15}:\s*)(.+)$/);
      var head = '';
      if (pre) { head = pre[1]; core = pre[2]; }
      var m = core.match(SIZE_RE);
      if (!m) return p;
      var fixed = capSize(m[1]) + (m[2] || '');
      if (fixed !== core) changed = true;
      return lead + head + fixed + trail;
    });
    return changed ? out.join(' / ') : null;
  }
  function fixSizes() {
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      var v = n.nodeValue;
      if (!v || v.length > 60 || !/[a-z]/.test(v)) continue;
      var pn = n.parentNode && n.parentNode.nodeName;
      if (pn === 'SCRIPT' || pn === 'STYLE' || pn === 'TEXTAREA') continue;
      var f = fixSizeText(v);
      if (f !== null) n.nodeValue = f;
    }
  }

  function init() {
    addHeaderIcon();
    addCardHearts();
    addProductButton();
    refresh();
    fixSizes();
  }
  function start() {
    init();
    if (location.hash === '#wishlist') openPanel();
  }

  var timer;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(init, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
